<script setup>
import IconClose from './icons/IconClose.vue';

defineProps({
  title: String,
  maxWidth: {
    type: String,
    default: '100%'
  },
  marginLeft: {
    type: String,
    default: '0'
  },
  maxHeight: {
    type: String,
    default: '100%'
  },
  titleIsCentered: Boolean,
  contentWithBorder: Boolean,
  onClose: Function
});

const emit = defineEmits(['close']);
</script>

<template>
  <div class="c-modal" @click.self="emit('close')">
    <div class="c-modal__body scale-in" :style="{maxWidth, marginLeft, maxHeight}">
      <div v-if="title" class="c-modal__title">
        <span :style="{textAlign: titleIsCentered ? 'center' : 'left'}">{{ title }}</span>
        <button type="button" @click="onClose" v-if="onClose">
          <icon-close/>
        </button>
      </div>
      <div class="c-modal__content" :class="contentWithBorder ? 'border-y' : undefined">
        <div class="c-modal__content__inner">
          <slot name="content"></slot>
        </div>
      </div>
      <div class="c-modal__actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.c-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  min-width: 100vw;
  height: 100vh;
  background: rgba(94, 47, 120, 0.08);
  font-family: var(--font);
  z-index: 1000;

  &__title {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    color: #1D1B20;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;

    span {
      width: 100%;
    }

    button {
      display: flex;
      margin: 0;
      padding: 5px;
      background-color: transparent;
      border: 0;
      border-radius: 50%;
      line-height: 1;
      cursor: pointer;
      transition: background-color 150ms linear;

      &:hover {
        background-color: #49454F1F;
      }
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    background-color: #fff;
    width: 640px;
    max-width: 80%;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  }

  &__content {
    font-family: var(--font);
    max-height: calc(80vh - 165px);
    padding: 16px 0;
    overflow-y: auto;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin: 0 -24px;
    text-align: left;

    &.border-y {
      border-top: 1px solid #CEC3CE;
      border-bottom: 1px solid #CEC3CE;
    }

    &__inner {
      padding: 0 24px;
    }

    p {
      margin: 0 0 16px;
      color: rgba(73, 69, 79, 1);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    column-gap: 15px;
    align-items: center;

    .label {
      font-weight: 700;
    }

    .form-button {
      margin-bottom: 0 !important;

      button {
        margin-bottom: 0 !important;
      }
    }
  }
}

.vue-rectangle-stencil {
  border: 1px solid !important;
}

.cropper-modal {
  &.c-modal {
    min-width: auto;
    height: 100%;
    overflow: hidden;
  }

  .c-modal__content {
    max-height: 100%;
    height: 100%;
    position: relative;
    overflow: auto;
  }
}
</style>
